import { useQuery } from "@tanstack/react-query";
import { HTTPError } from "ky";
import { api } from "@/api/client";
import type { User } from "@/api/types";

export function useCurrentUser() {
  return useQuery({
    queryKey: ["me"],
    queryFn: async (): Promise<User | null> => {
      try {
        return await api.get("me").json<User>();
      } catch (error) {
        if (error instanceof HTTPError && error.response.status === 401) {
          return null;
        }
        throw error;
      }
    },
    retry: false,
    staleTime: 5 * 60_000,
  });
}
